module.exports = __webpack_public_path__ + "static/img/fot2_act.fa78eeb0.png";